export const tags = {
  LEDGER: 'LEDGER',
  EXTERNAL: 'EXTERNAL',
  LAST_FUND: 'LAST FUNDING',
};
export const tagColors = {
  [tags.LEDGER]: 'bg-info-light text-info',
  [tags.EXTERNAL]: 'bg-warning-light text-warning',
  [tags.LAST_FUND]: 'bg-success-light text-success',
};
